import { render, staticRenderFns } from "./append.vue?vue&type=template&id=045b581c&scoped=true&"
import script from "./append.vue?vue&type=script&lang=js&"
export * from "./append.vue?vue&type=script&lang=js&"
import style0 from "./append.vue?vue&type=style&index=0&id=045b581c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045b581c",
  null
  
)

export default component.exports